import { render, staticRenderFns } from "./PathComponent.vue?vue&type=template&id=dcf25da2&scoped=true"
import script from "./PathComponent.vue?vue&type=script&lang=js"
export * from "./PathComponent.vue?vue&type=script&lang=js"
import style0 from "./PathComponent.vue?vue&type=style&index=0&id=dcf25da2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcf25da2",
  null
  
)

export default component.exports